import { useUpdateEffect } from 'ahooks'
import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import {
  DepositMethod,
  DepositMethodTextMap,
  DepositMethodUnitMap
} from '@eastcoal/shared/enums/DepositMethod'

import { EnvironmentDepositInputProps } from './interface'

// 不收取选项排在第一位 （浏览器会自动根据key值排序）
const options = mapNumberEnumOptions(DepositMethodTextMap).sort(optionA => {
  if (optionA.value === DepositMethod.NONE) {
    return -optionA.value
  }

  return 0
})

const Component = ({
  disabled,
  value = {},
  onChange
}: EnvironmentDepositInputProps) => {
  const isFree = value.environmentDepositMethod === DepositMethod.NONE
  // 当没有服务费时清空已输入的服务费金额
  useUpdateEffect(() => {
    if (isFree) {
      onChange?.({ ...value, environmentDepositValue: undefined })
    }
  }, [value.environmentDepositMethod])

  const handleSelectChange = (environmentDepositMethod: DepositMethod) => {
    onChange?.({
      ...value,
      environmentDepositMethod
    })
  }

  const handleInputChange = (
    environmentDepositValue: number | string | null
  ) => {
    onChange?.({
      ...value,
      environmentDepositValue: isNil(environmentDepositValue)
        ? 0
        : Number(environmentDepositValue)
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        disabled={disabled}
        options={options}
        value={value.environmentDepositMethod}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled || isFree}
        min={0}
        value={value.environmentDepositValue}
        style={{
          width: '100%'
        }}
        onChange={handleInputChange}
      />
      {!isNil(value.environmentDepositMethod) && (
        <span>{DepositMethodUnitMap[value.environmentDepositMethod]}</span>
      )}
    </Space.Compact>
  )
}

export const EnvironmentDepositInput = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
